import { Box, keyframes } from '@mui/material';

const rainbowRotate = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const RainbowBorder = ({
  children,
  speed = 3,
  borderWidth = 3,
  borderRadius = 16,
  colors = ['#ff0000', '#ff7f00', '#ffff00', '#00ff00', '#0000ff', '#4b0082', '#9400d3'],
  active = true,
}) => {
  if (!active) {
    return <>{children}</>;
  }

  const gradient = `linear-gradient(90deg, ${colors.join(', ')}, ${colors[0]})`;

  return (
    <Box
      sx={{
        position: 'relative',
        padding: `${borderWidth}px`,
        borderRadius: `${borderRadius}px`,
        background: gradient,
        backgroundSize: '200% 200%',
        animation: `${rainbowRotate} ${speed}s linear infinite`,
      }}
    >
      <Box
        sx={{
          borderRadius: `${borderRadius - borderWidth}px`,
          overflow: 'hidden',
          background: 'inherit',
          backgroundClip: 'padding-box',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default RainbowBorder;
